





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "information",
        components: {},
        mixins:[]
    })
    export default class information extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
